import React, { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest, deleteRequest } from '../../api/ApiController';
import {
    SaveIcon, AddIcon, CopyIcon, VerticalLineIcon,
    BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon,
    FavoriteIcon, PriceIcon, SaveAndCloseIcon
} from "../svg/svgIcons";
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { createAsyncNavigateHandlers } from '../../utils/asyncArrayNavigate';
import { navigationContextToQueryParams } from '../../utils/maintenanceNavigationContext';
import { Checkbox } from 'primereact/checkbox';
import { uiT } from '../../utils/uiTranslate';
const t = uiT;

const getLecturers = () => [
    { id: 0, name: uiT('Common.ServiceCompanyEmployee') },
    { id: 1, name: uiT('Common.InternalEmployee') },
];

export default function MaintenanceTypeAdd({ maintenance_type, type = 'add', navigationContext }) {

    const [state, dispatch] = useContext(DatabaseContext);
    const { user } = useContext(AuthContext);
    const { toast, openFavoriteDialog, setFastView, setDialogText, setVisible, openFilePreview } = useContext(UtilContext);
    const [closeTab, setCloseTab] = useState(false);

    const submitRef = useRef(null);

    const [formMaintenanceType, setFormMaintenanceType] = useState(maintenance_type);
    const [formType, setFormType] = useState(type);
    const [templateFile, setTemplateFile] = useState(null);
    const [typeTemplatePreview, setTypeTemplatePreview] = useState(null);
    const [companyContactsList, setCompanyContactsList] = useState([]);
    const [centralCompanyContacts, setCentralCompanyContacts] = useState([]);

    const [insertCopyIcon, setInsertCopyIcon] = useState((user.permissions?.includes("add maintenance")) ? false : true);
    const [scrollIcons, setScrollIcons] = useState((user.permissions?.includes("edit maintenance")) ? false : true);

    // CRUD – create new tab
    function addNewType() {
        dispatch({ type: 'create_new_tab', name: t('Maintenance.NewType'), translationKey: 'Maintenance.NewType', legacyLabel: t('Maintenance.NewType'), page: 'MaintenanceTypeAdd', props: { maintenance_type: null, type: 'add' }, mask: 'mntn002' })
    }

    function copyType() {
        dispatch({ type: 'create_new_tab', name: t('Maintenance.NewType'), translationKey: 'Maintenance.NewType', legacyLabel: t('Maintenance.NewType'), page: 'MaintenanceTypeAdd', props: { maintenance_type: formik.values, type: 'add' }, mask: 'mntn002' })
    }

    const validate = values => {
        const errors = {};
        if (!values.name) errors.name = '*Required';
        if (!values.machine_type_id) errors.machine_type_id = '*Required';
        return errors;
    };

    const formik = useFormik({
        initialValues: formMaintenanceType == null ? {
            name: '',
            type: '',
            norm: '',
            machine_type_id: '',
            interval_months: '',
            responsible_employee_id: '',
            description: '',
            state: 'Aktívny',
            use_central_responsible_person: false,
            use_central_service_person: false,
            use_unified_template: false,
            central_company_id: '',
            central_lecturer_id: '',
            central_company_contact_id: '',
            change_interval_in_ongoing: false,
            use_central_required_attachment: false
        } : {
            ...formMaintenanceType,
            state: formMaintenanceType?.state == null || formMaintenanceType?.state === '' ? 'Aktívny' : formMaintenanceType.state,
            use_central_responsible_person: !!formMaintenanceType?.use_central_responsible_person,
            use_central_service_person: !!formMaintenanceType?.use_central_service_person,
            use_unified_template: !!formMaintenanceType?.use_unified_template,
            central_company_id: formMaintenanceType?.central_company_id ?? '',
            central_lecturer_id: formMaintenanceType?.central_lecturer_id ?? '',
            central_company_contact_id: formMaintenanceType?.central_company_contact_id ?? '',
            change_interval_in_ongoing: false,
            use_central_required_attachment: !!formMaintenanceType?.use_central_required_attachment
        },
        enableReinitialize: true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                if (value === 'change_interval_in_ongoing') continue;
                if (value === 'use_central_responsible_person' || value === 'use_central_service_person' || value === 'use_unified_template' || value === 'use_central_required_attachment') {
                    formData.append(value, values[value] ? '1' : '0');
                } else {
                    formData.append(value, values[value] != null ? values[value] : "");
                }
            }
            if (formType === 'edit' && values.change_interval_in_ongoing) {
                formData.append('change_interval_in_ongoing', '1');
            }
            if (templateFile) {
                formData.append('template_file', templateFile);
            }

            if (formType === "add" || formType === "copy") {
                setDialogText?.(t('Common.Saving'));
                setVisible?.(true);
                postRequest('/api/maintenance_types', formData, true)
                    .then((response) => {
                        const newId = response?.data?.id;
                        if (closeTab) dispatch({ type: 'close_tab', id: state.selectedTab });
                        if (newId) {
                            setTemplateFile(null);
                            getRequest(`/api/maintenance_types/${newId}`).then((r) => {
                                const full = r?.data ?? r;
                                setFormMaintenanceType(full);
                                setFormType("edit");
                                formik.setValues({
                                    ...formik.values, ...full,
                                    state: full?.state == null || full?.state === '' ? 'Aktívny' : full.state,
                                    use_central_responsible_person: !!full?.use_central_responsible_person,
                                    use_central_service_person: !!full?.use_central_service_person,
                                    use_unified_template: !!full?.use_unified_template,
                                    central_company_id: full?.central_company_id ?? '',
                                    central_lecturer_id: full?.central_lecturer_id ?? '',
                                    central_company_contact_id: full?.central_company_contact_id ?? '',
                                    use_central_required_attachment: !!full?.use_central_required_attachment
                                });
                                toast?.current?.show({ severity: 'info', summary: 'Saved', life: 3000, detail: t('MaintenanceTypeAdd.Text.Zaznam_uspesne_pridany') });
                                setVisible?.(false);
                            }).catch(() => { setVisible?.(false); });
                        } else {
                            setFormType("edit");
                            toast?.current?.show({ severity: 'info', summary: 'Saved', life: 3000, detail: t('MaintenanceTypeAdd.Text.Zaznam_uspesne_pridany') });
                            setVisible?.(false);
                        }
                    }).catch(() => {
                        setVisible?.(false);
                        alert(t('Ui.R67.Error_while_saving'));
                    });
            } else {
                setDialogText?.(t('Common.Saving'));
                setVisible?.(true);
                postRequest(`/api/maintenance_types/update/${formik.values.id}`, formData, true)
                    .then((response) => {
                        setTemplateFile(null);
                        if (closeTab) dispatch({ type: 'close_tab', id: state.selectedTab });
                        const updated = response?.data;
                        if (updated) {
                            formik.setValues(prev => ({
                                ...prev,
                                ...updated,
                                use_central_responsible_person: !!updated?.use_central_responsible_person,
                                use_central_service_person: !!updated?.use_central_service_person,
                                use_unified_template: !!updated?.use_unified_template,
                                central_company_id: updated?.central_company_id ?? '',
                                central_lecturer_id: updated?.central_lecturer_id ?? '',
                                central_company_contact_id: updated?.central_company_contact_id ?? ''
                            }));
                        }
                        toast?.current?.show({ severity: 'info', summary: 'Updated', life: 3000, detail: t('MaintenanceTypeAdd.Text.Zaznam_upraveny') });
                        setVisible?.(false);
                    }).catch(() => {
                        setVisible?.(false);
                        alert(t('Ui.R67.Error_while_updating'));
                    });
            }
        },
    });

    const maintenanceCompanies = state.maintenance_companies || [];

    useEffect(() => {
        if ((state.maintenance_company_contacts || []).length > 0) return;
        getRequest('/api/company_contacts?minimal=1&module=maintenance')
            .then((r) => { const list = r?.data ?? r ?? []; setCompanyContactsList(Array.isArray(list) ? list : []); })
            .catch(() => {});
    }, [state.maintenance_company_contacts?.length]);

    const effectiveContacts = (state.maintenance_company_contacts || []).length ? (state.maintenance_company_contacts || []) : companyContactsList;

    useEffect(() => {
        const cid = formik.values.central_company_id;
        const lid = formik.values.central_lecturer_id;
        if (!cid) {
            setCentralCompanyContacts([]);
            return;
        }
        const base = effectiveContacts.filter(c => String(c.company_id) === String(cid));
        if (lid === '' || lid == null) {
            setCentralCompanyContacts(base);
            return;
        }
        const num = Number(lid);
        const filtered = num === 1 ? base.filter(c => c.employee_id != null) : base.filter(c => c.employee_id == null);
        setCentralCompanyContacts(filtered);
    }, [formik.values.central_company_id, formik.values.central_lecturer_id, effectiveContacts]);

    useEffect(() => {
        const id = formMaintenanceType?.id;
        const useUnified = formMaintenanceType?.use_unified_template;
        if (!id || !useUnified) {
            setTypeTemplatePreview(null);
            return;
        }
        getRequest(`/api/maintenance_types/${id}/template`)
            .then((res) => {
                const d = res?.data?.data ?? res?.data;
                if (d?.url) setTypeTemplatePreview({ url: d.url, filename: d.filename || 'predloha' });
                else setTypeTemplatePreview(null);
            })
            .catch(() => setTypeTemplatePreview(null));
    }, [formMaintenanceType?.id, formMaintenanceType?.use_unified_template]);

    function changeCentralCompany(companyId) {
        formik.setFieldValue('central_company_id', companyId || '');
        formik.setFieldValue('central_lecturer_id', '');
        formik.setFieldValue('central_company_contact_id', '');
    }

    function changeCentralLecturer(lecturerId) {
        formik.setFieldValue('central_lecturer_id', lecturerId ?? '');
        formik.setFieldValue('central_company_contact_id', '');
    }

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(() => {
        const buildFetchRecord = (toParams = () => '') => async (direction, currentId) => {
            setDialogText?.(t('Common.LoadingShort'));
            setVisible?.(true);
            try {
                const q = toParams();
                const url = `/api/maintenance_types/navigate?direction=${direction}${currentId ? '&id=' + currentId : ''}${q ? '&' + q : ''}`;
                const resp = await getRequest(url);
                return resp?.data ?? null;
            } finally {
                setVisible?.(false);
            }
        };
        if (navigationContext?.filters != null || navigationContext?.sorters != null) {
            const toParams = () => navigationContextToQueryParams(navigationContext);
            return createAsyncNavigateHandlers(buildFetchRecord(toParams), setFormMaintenanceType, () => formik.values?.id ?? formMaintenanceType?.id);
        }
        return createAsyncNavigateHandlers(buildFetchRecord(), setFormMaintenanceType, () => formik.values?.id ?? formMaintenanceType?.id);
    }, [navigationContext, formik.values?.id, formMaintenanceType?.id]);

    return (
        <>
            <div>
                {/* Toolbar */}
                <div className='w-full h-10 flex flex-row bg-[#333]'>
                    <div className='flex w-10 h-10 px-2 py-1 justify-center'>
                        <button disabled={insertCopyIcon} type='submit' onClick={() => { setCloseTab(true); submitRef.current.click(); }}>
                            <SaveAndCloseIcon />
                        </button>
                    </div>
                    <div className='flex w-10 h-10 px-2 py-1 justify-center'>
                        <button disabled={insertCopyIcon} type='submit' onClick={() => { submitRef.current.click(); }}>
                            <SaveIcon />
                        </button>
                    </div>
                    <div className='flex w-10 h-10 px-2 py-1 justify-center'>
                        <button disabled={insertCopyIcon} onClick={() => addNewType()}><AddIcon /></button>
                    </div>
                    <div className='flex w-10 h-10 px-2 py-1 justify-center'>
                        <button disabled={insertCopyIcon} onClick={() => copyType()}><CopyIcon /></button>
                    </div>
                    <div className='flex w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon /></div>
                    <div className='flex w-10 h-10 px-2 py-1 justify-center'>
                        <button onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon /></button>
                    </div>
                    <div className='flex w-10 h-10 px-2 py-1 justify-center'>
                        <button onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon /></button>
                    </div>
                    <div className='flex w-10 h-10 px-2 py-1 justify-center'>
                        <button onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon /></button>
                    </div>
                    <div className='flex w-10 h-10 px-2 py-1 justify-center'>
                        <button onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon /></button>
                    </div>
                    <div className='flex w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon /></div>
                    <div className='flex w-10 h-10 px-2 py-1 justify-center'>
                        <button onClick={() => openFavoriteDialog(t('Maintenance.NewType'), "MaintenanceTypeAdd")}><FavoriteIcon /></button>
                    </div>
                    <div className='flex w-10 h-10 px-2 py-1 justify-center'>
                        <button onClick={() => setFastView("MaintenanceTypeAdd")}><PriceIcon /></button>
                    </div>
                </div>

                {/* Form */}
                <form onSubmit={formik.handleSubmit}>
                    <div className="relative flex flex-col h-[calc(100vh-177px)] overflow-y-auto overflow-x-hidden">
                        <div className='xl:grid xl:grid-cols-2 gap-4 mb-2 px-4 py-4'>
                            {/* Ľavý stĺpec */}
                            <div className="w-auto p-6 bg-gray-100 rounded-md shadow-md">
                                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.TYP_UKONU_UDRZBY')}</h1>
                                {formType === "edit" && <label className="block text-md font-semibold text-gray-800">ID: {formik.values.id}</label>}
                                <div>
                                    <label className="block text-md font-semibold text-gray-800">{t('MachineTypeAdd.Label.Name')}</label>
                                    <input name='name' required type="text" onChange={formik.handleChange} value={formik.values.name}
                                        className="block w-full px-4 py-2 mt-2 border rounded-md focus:border-gray-400" />
                                </div>
                                <div>
                                    <label className="block text-md font-semibold text-gray-800 mt-2">{t('Ui.R67.DRUH_UKONU')}</label>
                                    <textarea name='type' onChange={formik.handleChange} value={formik.values.type}
                                        className="block w-full px-4 py-2 mt-2 border rounded-md focus:border-gray-400" />
                                </div>
                                <div>
                                    <label className="block text-md font-semibold text-gray-800 mt-2">NORMA</label>
                                    <textarea name='norm' onChange={formik.handleChange} value={formik.values.norm}
                                        className="block w-full px-4 py-2 mt-2 border rounded-md focus:border-gray-400" />
                                </div>
                                <div>
                                    <label className="block text-md font-semibold text-gray-800 mt-2">DRUH STROJA</label>
                                    <select name='machine_type_id' required onChange={formik.handleChange} value={formik.values.machine_type_id}
                                        className="block w-full px-4 py-2 mt-2 border rounded-md focus:border-gray-400">
                                        <option value="">-- Vyber druh stroja --</option>
                                        {state.machine_types?.map((mt) => (
                                            <option key={mt.id} value={mt.id}>{mt.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block text-md font-semibold text-gray-800 mt-2">{t('Common.IntervalMonths')}</label>
                                    <input name='interval_months' type="number" onChange={formik.handleChange} value={formik.values.interval_months}
                                        className="block w-full px-4 py-2 mt-2 border rounded-md focus:border-gray-400" />
                                </div>
                                {formType === 'edit' && (
                                    <div className="mt-3 flex items-center">
                                        <Checkbox
                                            inputId="change_interval_in_ongoing"
                                            checked={!!formik.values.change_interval_in_ongoing}
                                            onChange={(e) => formik.setFieldValue('change_interval_in_ongoing', e.checked)}
                                            className="mr-2"
                                        />
                                        <label htmlFor="change_interval_in_ongoing" className="font-normal text-md text-gray-800">{t('Ui.R67.Pri_zmene_intervalu_zmenit_aj_dalsi_termin_vo_vsetkych_prebi')}</label>
                                    </div>
                                )}
                                <div>
                                    <label className="block text-md font-semibold text-gray-800 mt-2">{t('Ui.R67.STAV_UKONU')}</label>
                                    <select name='state' onChange={formik.handleChange} value={formik.values.state ?? 'Aktívny'}
                                        className="block w-full px-4 py-2 mt-2 border rounded-md focus:border-gray-400">
                                        <option value="Aktívny">{t('Common.Active')}</option>
                                        <option value="Zrušený">{t('TrainingTypeList.Status.Cancelled')}</option>
                                    </select>
                                </div>
                            </div>

                            {/* Pravý stĺpec */}
                            <div className="w-auto p-6 bg-gray-100 rounded-md shadow-md">
                                <div>
                                    <label className="block text-md font-semibold text-gray-800">{t('Ui.R67.ZODPOVEDNA_OSOBA')}</label>
                                    <select name='responsible_employee_id' onChange={formik.handleChange} value={formik.values.responsible_employee_id}
                                        className="block w-full px-4 py-2 mt-2 border rounded-md focus:border-gray-400">
                                        <option value="">-- Vyber zamestnanca --</option>
                                        {state.employees?.map((emp) => (
                                            <option key={emp.id} value={emp.id}>{emp.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="mt-3 flex items-center">
                                    <Checkbox
                                        inputId="use_central_responsible_person"
                                        checked={!!formik.values.use_central_responsible_person}
                                        onChange={(e) => formik.setFieldValue('use_central_responsible_person', e.checked)}
                                        className="mr-2"
                                    />
                                    <label htmlFor="use_central_responsible_person" className="font-normal text-md text-gray-800">{t('Ui.R67.Pouzit_centralnu_zodpovednu_osobu_pouzije_sa_vo_vsetkych_kar')}</label>
                                </div>
                                <div>
                                    <label className="block text-md font-semibold text-gray-800 mt-2">{t('Common.DescriptionUpper')}</label>
                                    <textarea name='description' onChange={formik.handleChange} value={formik.values.description}
                                        className="block w-full px-4 py-2 mt-2 border rounded-md focus:border-gray-400" />
                                </div>
                                <div className="flex items-center mt-4">
                                    <Checkbox
                                        inputId="use_central_service_person"
                                        checked={!!formik.values.use_central_service_person}
                                        onChange={(e) => formik.setFieldValue('use_central_service_person', e.checked)}
                                        className="mr-2"
                                    />
                                    <label htmlFor="use_central_service_person" className="font-normal text-md text-gray-800">{t('Ui.R67.Pouzit_centralnu_servisnu_firmu_a_technika_firma_druh_techni')}</label>
                                </div>
                                {formik.values.use_central_service_person && (
                                    <>
                                        <div className="mt-3">
                                            <label htmlFor="central_company_id" className="block text-md font-semibold text-gray-800">{t('Common.ServiceCompany')}</label>
                                            <select
                                                id="central_company_id"
                                                value={formik.values.central_company_id || ''}
                                                onChange={(e) => changeCentralCompany(e.target.value)}
                                                className="block w-full px-4 py-2 mt-2 border rounded-md focus:border-gray-400"
                                            >
                                                <option value="">{t('Ui.R67.Vyber_serv_firmu_2')}</option>
                                                {maintenanceCompanies.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        {formik.values.central_company_id && (
                                            <div className="mt-3">
                                                <label htmlFor="central_lecturer_id" className="block text-md font-semibold text-gray-800">Druh technika</label>
                                                <select
                                                    id="central_lecturer_id"
                                                    value={formik.values.central_lecturer_id ?? ''}
                                                    onChange={(e) => changeCentralLecturer(e.target.value === '' ? '' : Number(e.target.value))}
                                                    className="block w-full px-4 py-2 mt-2 border rounded-md focus:border-gray-400"
                                                >
                                                    <option value="">{t('Ui.R67.Vyber_druh_technika')}</option>
                                                    {getLecturers().map((l) => (
                                                        <option key={l.id} value={l.id}>{l.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}
                                        {(formik.values.central_lecturer_id === 0 || formik.values.central_lecturer_id === 1 || formik.values.central_lecturer_id === '0' || formik.values.central_lecturer_id === '1') && (
                                            <div className="mt-3">
                                                <label htmlFor="central_company_contact_id" className="block text-md font-semibold text-gray-800">{t('Common.ServiceTechnician')}</label>
                                                <select
                                                    id="central_company_contact_id"
                                                    name="central_company_contact_id"
                                                    value={formik.values.central_company_contact_id || ''}
                                                    onChange={formik.handleChange}
                                                    className="block w-full px-4 py-2 mt-2 border rounded-md focus:border-gray-400"
                                                >
                                                    <option value="">{t('Ui.R67.Vyber_servisneho_technika')}</option>
                                                    {centralCompanyContacts.map((contact) => (
                                                        <option key={contact.id} value={contact.id}>{contact?.employee?.name || contact?.name || '—'}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}
                                    </>
                                )}
                                <div className="mt-3 flex items-center">
                                    <Checkbox
                                        inputId="use_central_required_attachment"
                                        checked={!!formik.values.use_central_required_attachment}
                                        onChange={(e) => formik.setFieldValue('use_central_required_attachment', e.checked)}
                                        className="mr-2"
                                    />
                                    <label htmlFor="use_central_required_attachment" className="font-normal text-md text-gray-800">{t('Ui.R67.Povinna_priloha_centralne_zadana_v_kartach_stroja_sa_zobrazi')}</label>
                                </div>
                                <div className="mt-3 flex items-center">
                                    <Checkbox
                                        inputId="use_unified_template"
                                        checked={!!formik.values.use_unified_template}
                                        onChange={(e) => formik.setFieldValue('use_unified_template', e.checked)}
                                        className="mr-2"
                                    />
                                    <label htmlFor="use_unified_template" className="font-normal text-md text-gray-800">{t('Ui.R67.Pouzit_jednotnu_predlohu_subor_sa_nahraje_na_vsetky_karty_to')}</label>
                                </div>
                                {formik.values.use_unified_template && (
                                    <div className="mt-2">
                                        <label className="block text-md font-semibold text-gray-800">{t('Ui.R67.Subor_predlohy')}</label>
                                        {formMaintenanceType?.template_filename && !templateFile && (
                                            <div className="mt-2 flex flex-row p-2 items-start">
                                                {typeTemplatePreview?.url ? (
                                                    <>
                                                        <div className="cursor-pointer" onClick={() => openFilePreview({ url: typeTemplatePreview.url, filename: typeTemplatePreview.filename })}>
                                                            <embed src={typeTemplatePreview.url + '#view=FitH&scrollbar=0'} width="100px" height="65px" title={typeTemplatePreview.filename} />
                                                        </div>
                                                        <div className="flex flex-col ml-4">
                                                            <a style={{ color: 'blue', cursor: 'pointer', marginBottom: '2px' }} onClick={() => openFilePreview({ url: typeTemplatePreview.url, filename: typeTemplatePreview.filename })}>
                                                                {typeTemplatePreview.filename}
                                                            </a>
                                                            <span className="text-sm text-gray-600">{t('Ui.R67.klik_pre_nahlad')}</span>
                                                            <button
                                                                type="button"
                                                                className="w-fit flex flex-row px-2 py-1 mt-2 border rounded-md bg-red-900 text-white text-sm"
                                                                onClick={() => {
                                                                    if (!formMaintenanceType?.id) return;
                                                                    deleteRequest(`/api/maintenance_types/${formMaintenanceType.id}/template`)
                                                                        .then(() => {
                                                                            setTypeTemplatePreview(null);
                                                                            getRequest(`/api/maintenance_types/${formMaintenanceType.id}`).then((r) => {
                                                                                const full = r?.data ?? r;
                                                                                setFormMaintenanceType(full);
                                                                            });
                                                                            toast?.current?.show({ severity: 'info', summary: t('MaintenanceTypeAdd.Text.Predloha_vymazana'), life: 3000 });
                                                                        })
                                                                        .catch(() => toast?.current?.show({ severity: 'error', summary: 'Chyba', detail: t('MaintenanceTypeAdd.Text.Predlohu_sa_nepodarilo_vymazat'), life: 3000 }));
                                                                }}
                                                            >
                                                                Vymazať
                                                            </button>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="flex flex-col">
                                                        <span className="text-sm text-gray-600">Aktuálny súbor: {formMaintenanceType.template_filename}</span>
                                                        <button
                                                            type="button"
                                                            className="w-fit flex flex-row px-2 py-1 mt-2 border rounded-md bg-red-900 text-white text-sm"
                                                            onClick={() => {
                                                                if (!formMaintenanceType?.id) return;
                                                                deleteRequest(`/api/maintenance_types/${formMaintenanceType.id}/template`)
                                                                    .then(() => {
                                                                        setTypeTemplatePreview(null);
                                                                        getRequest(`/api/maintenance_types/${formMaintenanceType.id}`).then((r) => {
                                                                            const full = r?.data ?? r;
                                                                            setFormMaintenanceType(full);
                                                                        });
                                                                        toast?.current?.show({ severity: 'info', summary: t('MaintenanceTypeAdd.Text.Predloha_vymazana'), life: 3000 });
                                                                    })
                                                                    .catch(() => toast?.current?.show({ severity: 'error', summary: 'Chyba', detail: t('MaintenanceTypeAdd.Text.Predlohu_sa_nepodarilo_vymazat'), life: 3000 }));
                                                            }}
                                                        >
                                                            Vymazať
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        <input
                                            type="file"
                                            accept=".pdf,.doc,.docx,.xls,.xlsx,image/*"
                                            onChange={(e) => setTemplateFile(e.target.files?.[0] || null)}
                                            className="block w-full px-4 py-2 mt-2 border rounded-md focus:border-gray-400"
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                        <button type="submit" ref={submitRef} className='hidden'></button>
                    </div>
                </form>
            </div>
        </>
    );
}